module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "new-campaign-terms-and-conditions"
  }, [_c('p', {
    staticClass: "title-text mt-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.termsAndConditions.title')))]), _vm._v(" "), _c('p', {
    staticClass: "body-text text-center mt-4"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.termsAndConditions.introductionText')))]), _vm._v(" "), _c('v-container', {
    staticClass: "terms-and-conditions-container my-0 px-6 py-2"
  }, [(_vm.loadingTermsAndConditions) ? _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "loading-icon",
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "3",
      "color": "#0098E1"
    }
  })], 1) : (_vm.termsAndConditions) ? [_c('p', {
    staticClass: "title-text mt-2"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.termsAndConditions.t&cTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "body-text mt-4",
    domProps: {
      "innerHTML": _vm._s(_vm.replaceWithBr(_vm.termsAndConditions.text[_vm.i18n.locale]))
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "disabled": _vm.campaign.preDataSteps[_vm.FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.T_AND_C],
      "label": _vm.$t('NewCampaignInitialData.termsAndConditions.checkboxLabel'),
      "hide-details": ""
    },
    on: {
      "change": _vm.checkboxChange
    },
    model: {
      value: (_vm.acceptedTermsAndConditions),
      callback: function($$v) {
        _vm.acceptedTermsAndConditions = $$v
      },
      expression: "acceptedTermsAndConditions"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2 action-row",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "color": "#0098E1",
      "disabled": !_vm.termsAndConditions || !_vm.acceptedTermsAndConditions,
      "loading": _vm.loadingButton
    },
    on: {
      "click": function($event) {
        return _vm.agreeTermsAndConditions()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.termsAndConditions.next')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7252f4db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/NewCampaignTermsAndConditions.vue
// module id = 1729
// module chunks = 0